import React, { useEffect } from "react";
import { Button, Descriptions, Space, PageHeader } from "antd";
import { connect } from "react-redux";
import {
  getSaving,
  toggleSavingsLock,
} from "../../state/actions/savingActions";
import { useParams, useHistory } from "react-router-dom";
import { helpers, dateUtil } from "../../utils";

function Saving(props) {
  const {
    getSaving: getOneSaving,
    saving,
    toggleSavingsLock: toggleLock,
    loadingUpdateSaving,
  } = props;

  const { savingsId } = useParams();
  const history = useHistory();

  useEffect(() => {
    async function getSaving() {
      try {
        await getOneSaving(savingsId);
      } catch (e) {
        helpers.displayMessage(e);
      }
    }

    getSaving();
  }, [savingsId, getOneSaving]);

  async function savingsLock() {
    try {
      const updatedSaving = await toggleLock(savingsId);
      helpers.successModal({
        title: "Saving plan changed",
        content: `This savings plan has been ${
          updatedSaving?.locked ? "Locked" : "Unlocked"
        }`,
      });
    } catch (e) {
      helpers.displayMessage(e);
    }
  }

  function allTransactions() {
    const userId = saving?.userId?._id;
    history.push(`/dashboard/users/${userId}/transactions?user=${userId}`, {
      user: saving?.userId,
    });
  }
  function debitTransactions() {
    const userId = saving?.userId?._id;
    history.push(
      `/dashboard/users/${userId}/transactions?user=${userId}&sourceId=${saving?._id}`,
      {
        user: saving?.userId,
      }
    );
  }
  function creditTransactions() {
    const userId = saving?.userId?._id;
    history.push(
      `/dashboard/users/${userId}/transactions?user=${userId}&destinationId=${saving?._id}`,
      {
        user: saving?.userId,
      }
    );
  }

  return (
    <Space direction="vertical" size="large" style={{ display: "flex" }}>
      <PageHeader
        className="site-page-header"
        onBack={() => history.goBack()}
        title="Back"
      />
      <Descriptions
        bordered
        title={`${saving?.userId?.first_name} ${saving?.userId?.last_name}`}
        size="default"
        extra={
          <Button
            loading={loadingUpdateSaving}
            onClick={savingsLock}
            type="primary"
          >
            {saving?.locked ? "Unlock Plan" : "Lock Plan"}
          </Button>
        }
      >
        <Descriptions.Item label="Plan Name">{saving?.name}</Descriptions.Item>
        <Descriptions.Item label="Contributions">
          {helpers.toCurrency(saving?.contribution)}
        </Descriptions.Item>
        <Descriptions.Item label="Frequency">
          {saving?.frequency}
        </Descriptions.Item>
        <Descriptions.Item label="Balance">
          {helpers.toCurrency(saving?.balance)}
        </Descriptions.Item>
        <Descriptions.Item label="Status">{saving?.status}</Descriptions.Item>
        <Descriptions.Item label="Tenor">
          {saving?.tenure} Months
        </Descriptions.Item>
        <Descriptions.Item label="Plan Type">{saving?.type}</Descriptions.Item>
        <Descriptions.Item label="Created On">
          {dateUtil.formatDate(saving?.createdAt)}
        </Descriptions.Item>
        <Descriptions.Item label="Starts On">
          {dateUtil.formatDate(saving?.startDate)}
        </Descriptions.Item>
        <Descriptions.Item label="Ends On">
          {dateUtil.formatDate(saving?.expectedEndDate)}
        </Descriptions.Item>
        <Descriptions.Item label="Total withdrawn">
          {helpers.toCurrency(saving?.totalAmountWithdrawn)}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        bordered
        title={`${
          saving?.status !== "terminated"
            ? "Next payment due on: "
            : "Last payment was due on: "
        }${dateUtil.formatDate(saving?.nextPaymentDueDate)}`}
        size="default"
        // extra={<Button type="link">View Transactions</Button>}
        extra={
          <Space size="small">
            {/* <Button type="primary">All Transactions</Button> */}
            <Button onClick={debitTransactions}>Debits</Button>
            <Button type="primary" onClick={creditTransactions}>
              Credits
            </Button>
          </Space>
        }
      />
    </Space>
  );
}

const mapStateToProps = (state) => {
  return {
    saving: state.savingsReducer.saving,
    loadingUpdateSaving: state.savingsReducer.loadingUpdateSaving,
  };
};

export default connect(mapStateToProps, { getSaving, toggleSavingsLock })(
  Saving
);
